import type { GitArtifactPayloadAction } from "git/store/types";
import type { ToggleCDResponse } from "../requests/toggleCDRequest";
import { call, put, select } from "redux-saga/effects";
import toggleCDRequest from "../requests/toggleCDRequest";
import { validateResponse } from "sagas/ErrorSagas";
import { gitArtifactActions } from "git/store/gitArtifactSlice";
import { selectGitApiContractsEnabled } from "git/store/selectors/gitFeatureFlagSelectors";
import handleApiErrors from "git/sagas/helpers/handleApiErrors";

export function* toggleCDSaga(action: GitArtifactPayloadAction) {
  const { artifactDef } = action.payload;
  let response: ToggleCDResponse | undefined;

  try {
    const isGitApiContractsEnabled: boolean = yield select(
      selectGitApiContractsEnabled,
    );

    response = yield call(
      toggleCDRequest,
      artifactDef.artifactType,
      artifactDef.baseArtifactId,
      isGitApiContractsEnabled,
    );
    const isValidResponse: boolean = yield validateResponse(response);

    if (response && isValidResponse) {
      yield put(gitArtifactActions.toggleCDSuccess({ artifactDef }));
      yield put(gitArtifactActions.fetchMetadataInit({ artifactDef }));
    }
  } catch (e) {
    const error = handleApiErrors(e as Error, response);

    if (error) {
      yield put(gitArtifactActions.toggleCDError({ artifactDef, error }));
    }
  }
}
